// Queen Blaire FAQ Items
import { LocationCountry } from '../constants/Constants';

/* -----------------------------------------
   ABOUT ME PAGE
----------------------------------------- */
export const aboutPageFaqItems = [
  {
    q: 'Where are you based?',
    a: `I am based in the ${LocationCountry}, and I accept both online worshippers and in-person applicants when appropriate.`,
  },
  {
    q: 'Do you allow new submissives?',
    a: `Yes — if they approach Me properly, respectfully, and with tribute ready. Worthy applicants may be considered.`,
  },
  {
    q: 'What makes you different from other Dominatrices?',
    a: 'My muscular physique, strict standards, authentic power, and high expectations separate Me from the rest. I do not play games — I dominate.',
  },
  {
    q: 'How can I request to serve you?',
    a: 'Use the Contact page and follow the instructions carefully. Low-effort messages are ignored.',
  },
];

/* -----------------------------------------
   CONTACT PAGE
----------------------------------------- */
export const contactPageFaqItems = [
  {
    q: 'How soon will I receive a reply?',
    a: 'I respond when I choose to. Usually within 24–48 hours if your message is respectful and includes tribute.',
  },
  {
    q: 'Can I speak with you before booking?',
    a: 'Only after a tribute is sent. I do not waste time on uncertain or unserious submissives.',
  },
  {
    q: 'How do I contact you for sessions?',
    a: 'Fill out the contact form and ensure your request is clear, respectful, and includes all required screening information.',
  },
];

/* -----------------------------------------
   HOME PAGE
----------------------------------------- */
export const homePageFaqItems = [
  {
    q: 'Who is Queen Blaire?',
    a: 'A powerful Muscle Goddess and Elite Dominatrix who demands excellence, obedience, and proper tribute.',
  },
  {
    q: 'Do you accept new submissives?',
    a: 'Only those who follow directions and show genuine devotion. I reject time-wasters instantly.',
  },
  {
    q: 'What is the best way to serve you?',
    a: 'Explore My Sessions, Links, and Tribute options — then approach through the Contact page respectfully.',
  },
];

/* -----------------------------------------
   GALLERY PAGE
----------------------------------------- */
export const galleryPageFaqItems = [
  {
    q: 'Can I download your photos?',
    a: 'No. My images are for viewing only. Unauthorized use or reposting is strictly forbidden.',
  },
  {
    q: 'Do you have premium or NSFW galleries?',
    a: 'Yes. Access is available through My Clips and Fansites pages.',
  },
  {
    q: 'Are the photos updated often?',
    a: 'Yes. I share new visual content frequently for loyal admirers and devoted subs.',
  },
];

/* -----------------------------------------
   LOCKTOBER PAGE
----------------------------------------- */
export const locktoberPageFaqItems = [
  {
    q: 'Do I need permission to join Locktober under you?',
    a: 'Yes. Submissives must pledge devotion and follow My rules. Unauthorized participation is not accepted.',
  },
  {
    q: 'Do you require proof of chastity?',
    a: 'Absolutely. Proof updates are mandatory. Failure results in consequences.',
  },
  {
    q: 'Can beginners join?',
    a: 'Yes — as long as you obey, report correctly, and accept the challenge fully.',
  },
];

/* -----------------------------------------
   SESSIONS PAGE
----------------------------------------- */
export const sessionsPageFaqItems = [
  {
    q: 'Do you offer in-person sessions?',
    a: 'Yes, for pre-approved submissives who pass My screening and submit tribute properly.',
  },
  {
    q: 'Do you offer online domination?',
    a: 'Yes. Video, audio, text, and task-based domination are all available.',
  },
  {
    q: 'What are the tribute requirements?',
    a: 'Tribute depends on session type, duration, and intensity. Minimum tributes are listed on the page.',
  },
  {
    q: 'What fetishes do you specialize in?',
    a: 'Muscle worship, BDSM, domination, roleplay, chastity, edging control, humiliation, discipline, and more.',
  },
];

/* -----------------------------------------
   FANSITES PAGE
----------------------------------------- */
export const fansitesPageFaqItems = [
  {
    q: 'Where can I find your premium content?',
    a: 'All verified platforms are linked on this page — only use these official sites.',
  },
  {
    q: 'Can I request custom content?',
    a: 'Yes, on select platforms. Custom content requires payment upfront.',
  },
  {
    q: 'Are you active on these platforms?',
    a: 'Yes. I post regularly for My loyal fans and devoted worshippers.',
  },
];

/* -----------------------------------------
   CLIPS PAGE
----------------------------------------- */
export const clipsPageFaqItems = [
  {
    q: 'Do you create custom clips?',
    a: 'Yes — for respectful, fully-paying slaves. No exceptions.',
  },
  {
    q: 'Where can I buy your videos?',
    a: 'All official clip stores are linked here. Do NOT use unverified sites.',
  },
  {
    q: 'Do you offer fetish-specific clips?',
    a: 'Absolutely. I produce clips across a wide range of BDSM and fetish categories.',
  },
];

/* -----------------------------------------
   LINKS PAGE
----------------------------------------- */
export const linksPageFaqItems = [
  {
    q: 'What is the best way to tribute you?',
    a: 'CashApp or Throne are preferred. All verified tribute options are listed on this page.',
  },
  {
    q: 'How do I know these are your real links?',
    a: 'Every link here is authenticated and controlled by Me. If it’s not listed, it is NOT Mine.',
  },
  {
    q: 'Can I send gifts?',
    a: 'Yes. Throne is My official wishlist for gifts, lingerie, outfits, and gear.',
  },
];

/* -----------------------------------------
   MAILING LIST PAGE
----------------------------------------- */
export const mailingListFaqItems = [
  {
    q: 'What will I receive if I join?',
    a: 'Updates about availability, new content, events, Locktober, and exclusive instructions for devoted subs.',
  },
  {
    q: 'How often do you send emails?',
    a: 'Only when I have something worth your attention — no spam, only dominance.',
  },
  {
    q: 'Can I unsubscribe?',
    a: 'Yes. If you can’t handle the heat, you may remove yourself at any time.',
  },
];

/* -----------------------------------------
   POLICIES PAGE
----------------------------------------- */
export const policiesPageFaqItems = [
  {
    q: 'Do you refund tributes or session payments?',
    a: 'Absolutely not. All tributes and payments are final.',
  },
  {
    q: 'Do you share personal information?',
    a: 'No. Screening details and messages are kept confidential.',
  },
  {
    q: 'How do you handle inappropriate behavior?',
    a: 'Instant block. No second chances.',
  },
];

/* -----------------------------------------
   ERROR / 404 PAGE
----------------------------------------- */
export const errorPageFaqItems = [
  {
    q: 'Why am I seeing this page?',
    a: 'You likely clicked a broken or outdated link — or tried to access something unauthorized.',
  },
  {
    q: 'How do I get back?',
    a: 'Return to the Home page or navigate using the main menu.',
  },
];

/* -----------------------------------------
   MAINTENANCE PAGE
----------------------------------------- */
export const maintenancePageFaqItems = [
  {
    q: 'When will the site be back?',
    a: 'Soon. Good things take time.',
  },
  {
    q: 'Can I still contact you?',
    a: 'Yes — My official Links & Tribute page remains active.',
  },
];
